import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white text-center py-6">
      <p>&copy; {new Date().getFullYear()} FitZone Gym. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
